import { Device, Document, DocumentVersion } from "@models";
import { DocStatus, Template } from "@types";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "src/config";
import { ROUTE_SLUGS } from "src/config/navigation/routes";
import { allStepsCompleted, fillRouteWithSlugs } from "src/utils";

export const useAnswerQuestionsAction = ({
  selectedDoc,
  selectedVersion,
  device,
  documents,
  templateConfig,
  isEnabled = true,
}: {
  selectedDoc?: Document;
  selectedVersion?: DocumentVersion;
  device?: Device;
  documents?: Document[];
  templateConfig?: Template;
  docVersionStatus: DocStatus;
  isEnabled?: boolean;
}) => {
  const navigate = useNavigate();
  const { orgId = "", deviceId = "" } = useParams();

  const canRunAction =
    isEnabled && !!selectedDoc && !!selectedVersion && !!device && !!documents;

  const allAnswered =
    canRunAction && templateConfig
      ? allStepsCompleted(selectedVersion, device, documents, templateConfig)
      : true;

  const navigateToTemplateAssistant = () => {
    if (!canRunAction || !selectedDoc || !selectedVersion) {
      return;
    }

    const searchParams = new URLSearchParams();
    searchParams.set("v", selectedVersion.id);

    navigate({
      pathname: fillRouteWithSlugs(ROUTES.DOCUMENT_ASSISTANT, {
        [ROUTE_SLUGS.ORG_ID]: orgId,
        [ROUTE_SLUGS.DEVICE_ID]: deviceId,
        [ROUTE_SLUGS.DOC_ID]: selectedDoc.id,
      }),
      search: `?${searchParams.toString()}`,
    });
  };

  const onAnswerQuestionsClick = () => {
    if (!canRunAction) {
      return;
    }

    navigateToTemplateAssistant();
  };

  const tooltipContent = !canRunAction
    ? ""
    : allAnswered
      ? "Click to change answers"
      : "Click to finish answering questions and regenerate";

  return {
    allAnswered,
    confirmationModal: null,
    isPending: false,
    onAnswerQuestionsClick,
    tooltipContent,
  };
};

export default useAnswerQuestionsAction;
